import React from 'react';
import { func, array, object, string } from 'prop-types';
import { translate } from 'react-i18next';
import { compose } from 'redux';
import { connect } from 'react-redux';

import MainLayout from '@blueberry/layouts/MainLayout';

import SEOHead from '@blueberry/components/SEOHead';
import NotFound from '@blueberry/components/NotFound';
import ChannelBar from '@blueberry/components/ChannelBar';
import PostList from '@blueberry/components/PostList';
import Breadcrumb from '@blueberry/components/Breadcrumb';

import { ERROR } from '@blueberry/constants/loadingState';

import { getChannels } from '@blueberry/redux/channel';

import { fetchSubjectPageFlow } from '@blueberry/sagas/subjectPage';
import {
  getCurriculum,
  getSubject,
  getStatus,
} from '@blueberry/redux/subjectPage';
import { getPagePosts } from '@blueberry/redux/pagePost';

import styles from './SubjectPage.scss';

const mapStateToProps = state => ({
  channels: getChannels(state),
  curriculum: getCurriculum(state),
  subject: getSubject(state),
  posts: getPagePosts(state),
  status: getStatus(state),
});

function SubjectPage({ t, channels, curriculum, subject, posts, status }) {
  const seoParams = { curriculum: curriculum.name, subject: subject.name };
  const seoComponent = (
    <SEOHead
      title={t('seo.subjectPage.title', seoParams)}
      description={t('seo.subjectPage.description', seoParams)}
    />
  );
  const breadcrumbItems = [
    {
      name: curriculum.name,
    },
  ];

  const getNameHref = channel =>
    `/subject/${subject.name}-${subject.id}/${channel.name}-${channel.id}`;

  const renderContent = (
    <main className={styles.root}>
      <Breadcrumb items={breadcrumbItems} />
      <h1 className={styles.title}>{subject.name}</h1>
      {channels
        .filter(channel => channel.posts.length > 0)
        .map(channel => (
          <ChannelBar
            key={channel.name}
            nameHref={getNameHref(channel)}
            {...channel}
          />
        ))}
      {posts.length > 0 && (
        <PostList title={t('post:post.title')} posts={posts} />
      )}
    </main>
  );

  return (
    <MainLayout showFooter>
      {seoComponent}
      {status === ERROR ? <NotFound /> : renderContent}
    </MainLayout>
  );
}

SubjectPage.prefetch = ({ id }) => [fetchSubjectPageFlow, { payload: { id } }];

SubjectPage.propTypes = {
  curriculum: object.isRequired,
  status: string.isRequired,
  subject: object.isRequired,
  t: func.isRequired,
  channels: array,
  posts: array,
};

SubjectPage.defaultProps = {
  channels: [],
  posts: [],
};

export default compose(
  translate(['seo', 'post']),
  connect(mapStateToProps)
)(SubjectPage);



// WEBPACK FOOTER //
// ./app/containers/SubjectPage/SubjectPage.jsx